// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 7349) return "static/chunks/7349-8c91fa60b92a86c3.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 950 ? "5b4b5207" : chunkId) + "." + {"403":"7fa9d20e9c6ea680","822":"d65c0f43122a0d21","950":"db5a61e4d106ff2c","6039":"416c83c8c3918a31","8114":"9a8850fcc8ce7673"}[chunkId] + ".js";
};